/** Apenas dígitos, máximo 11 (legado CPF). */
export function onlyCpfDigits(s: string): string {
  return s.replace(/\D/g, "").slice(0, 11);
}

/** Apenas dígitos, máximo 14 (CPF ou CNPJ). */
export function onlyDocumentDigits(s: string): string {
  return s.replace(/\D/g, "").slice(0, 14);
}

/** Máscara visual 000.000.000-00 */
export function formatCpfMask(digits: string): string {
  const d = onlyCpfDigits(digits);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
  if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9, 11)}`;
}

function formatCnpjMask(digits: string): string {
  const d = onlyDocumentDigits(digits).slice(0, 14);
  if (d.length <= 2) return d;
  if (d.length <= 5) return `${d.slice(0, 2)}.${d.slice(2)}`;
  if (d.length <= 8) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5)}`;
  if (d.length <= 12) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8)}`;
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12, 14)}`;
}

/**
 * Máscara dinâmica: até 11 dígitos CPF; a partir do 12º, CNPJ.
 */
export function formatCpfCnpjMask(digits: string): string {
  const d = onlyDocumentDigits(digits);
  if (d.length <= 11) return formatCpfMask(d);
  return formatCnpjMask(d);
}

export function validarCpf11(digits: string): boolean {
  const c = onlyCpfDigits(digits);
  if (c.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(c)) return false;
  for (let t = 9; t < 11; t++) {
    let sum = 0;
    for (let i = 0; i < t; i++) {
      sum += parseInt(c[i]!, 10) * (t + 1 - i);
    }
    let digit = (sum * 10) % 11;
    if (digit === 10) digit = 0;
    if (parseInt(c[t]!, 10) !== digit) return false;
  }
  return true;
}

export type ConsumidorDocumentoKind = "" | "cpf" | "cnpj";

/** Valida comprimento/tipo; vazio é permitido. */
export function validarDocumentoConsumidor(digits: string): { ok: true; kind: ConsumidorDocumentoKind } | { ok: false } {
  const d = onlyDocumentDigits(digits);
  if (d.length === 0) return { ok: true, kind: "" };
  if (d.length === 11) return validarCpf11(d) ? { ok: true, kind: "cpf" } : { ok: false };
  if (d.length === 14) return { ok: true, kind: "cnpj" };
  return { ok: false };
}

export function formatDocumentoConsumidorLabel(digits: string, kind: ConsumidorDocumentoKind): string {
  const d = onlyDocumentDigits(digits);
  if (kind === "cpf" && d.length === 11) return `CPF: ${formatCpfCnpjMask(d)}`;
  if (kind === "cnpj" && d.length === 14) return `CNPJ: ${formatCpfCnpjMask(d)}`;
  return "Cliente não identificado";
}
